
const digest = '77f0221467b9d4cdd0b0b78575a1b86688b77f048382c23c8f94094a74b1310c';
const classes = {"title":"_title_1kh8m_1"};
const css = `._title_1kh8m_1 {
  padding: 10px;
  cursor: pointer;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  